export default __webpack_public_path__ + "static/media/ip-blocked.bf445b30.svg";